import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { AuthSignOutButton } from "@/components/features/auth/sign-out/button";

import { Button } from "@/components/ui/button/button";
import { Image } from "@/components/ui/image/image";

export const CompanyTopInnerHeader = () => {
	const navigate = useNavigate();
	const setUpPagePath = generatePath(PATHS.SETUP);

	/**
	 * ホテル追加ボタンをクリックした時の処理
	 */
	const handleClickAddHotelButton = useCallback(() => {
		navigate(setUpPagePath);
	}, [navigate, setUpPagePath]);

	return (
		<div className="flex flex-col items-center space-y-8 lg:flex-row lg:justify-between">
			<div>
				<Image src="/chillnn-logo-black.png" className="aspect-video h-20" />
			</div>

			<div className="xs:justify-end flex flex-wrap justify-center gap-4">
				<Button onClick={handleClickAddHotelButton} type="button" variant="default">
					ホテル追加
				</Button>

				<AuthSignOutButton variant="outline" />
			</div>
		</div>
	);
};

CompanyTopInnerHeader.displayName = "CompanyTopInnerHeader";
